<template>
  <section class="clipFolderSkeleton">
    <v-skeleton-loader type="card-avatar"></v-skeleton-loader>
  </section>
</template>
<script>
export default {
  name: 'ClipFolderSkeleton',
};
</script>
<style lang="scss">
.clipFolderSkeleton {
  padding: 10px 0;
  border-bottom: solid #ccc 1px;

  .v-skeleton-loader {
    max-width: 200px !important;
  }
  .v-skeleton-loader__image {
    display: none;
  }
  .v-skeleton-loader__avatar {
    width: 25px;
    height: 25px;
  }
}
</style>
